import { MfsError } from '@metaos/mfs-telemetry';
/**
 * @param message The message that will be returned to the user
 * @param isRetriable Returns true if the specified HTTP status / error code is returned in a transient / retriable error condition
 * @param eventName Identification of the event that triggered the error
 * @param MfsStatusCode Mfs Status Code to indicate whether the status of the request.
 */
export class MfsFolderError extends MfsError {
    constructor(message, isRetriable, eventName, mfsStatusCode) {
        super(message, mfsStatusCode);
        this.isRetriable = isRetriable;
        this.eventName = eventName;
        this.mfsStatusCode = mfsStatusCode;
    }
}
//# sourceMappingURL=mfsFolderError.js.map